import Vue from 'vue'



// 默认日本
var distributor = "JAPAN"
var appName = "E.P.SUIT"
if(window.location.host.indexOf("hintime") >= 0){
  distributor = "ITALY_HINTIME"
  appName = "HINTIME"
}else if(window.location.host.indexOf("italy") >= 0){
  distributor = "ITALY"
  appName = "MMK Impuls"
}else if(window.location.host.indexOf("sauems20") >= 0 || window.location.host.indexOf("ems20") >= 0){
    distributor = "SAU_EMS20"
    appName = "EMS 2.0"
}else if(window.location.host.indexOf("mx30fit") >= 0 || window.location.host.indexOf("30minutesfit") >= 0){
    distributor = "MX_30FIT"
    appName = "30 Minutes Fit® EMS"
}else if(window.location.host.indexOf("maxplenu") >= 0){
    distributor = "MAX_PLENU"
    appName="Evolluxor"
}else if(window.location.host.indexOf("ubody") >= 0){
    distributor = "UBODY_EMS"
    appName="Ubody EMS"
}else if(window.location.host.indexOf("empsme") >= 0){
    distributor = "EMPSME"
    appName="Empsme"
}else if(window.location.host.indexOf("zakakou") >= 0){
    distributor = "EMS_ZAKAKOU"
    appName="ZAKAKOU"
}


if(window.location.host.indexOf("192.168")>=0 || window.location.host.indexOf("localhost")>=0){
    
    // distributor = "SAU_EMS20"
    // appName = "EMS 2.0"

    // distributor = "MAX_PLENU"
    // appName="Evolluxor"

    // distributor = "ITALY_HINTIME"
    // appName = "HINTIME"

    // distributor = "MX_30FIT"
    // appName = "30 Minutes Fit® EMS"

    // distributor = "ITALY"
    // appName = "MMK Impuls"

    // distributor = "EMPSME"
    // appName="empsme"

    
    distributor = "EMS_ZAKAKOU"
    appName="ZAKAKOU"
}

Vue.prototype.distributor = distributor
Vue.prototype.appName = appName
console.log("store app.js distributor:" + distributor)
console.log("store app.js appName:" + appName)

window.document.title = appName

console.log("store app distributor:" + Vue.prototype.distributor)
export default {

    state: {
        logo: Vue.prototype.appName + ".png",
        appName: Vue.prototype.appName,  // 应用名称
        themeColor: Vue.prototype.distributor == 'MX_30FIT' || Vue.prototype.distributor == 'MAX_PLENU' ? "#000000" : "#14889A",  // 主题颜色
        oldThemeColor: Vue.prototype.distributor == 'MX_30FIT' || Vue.prototype.distributor == 'MAX_PLENU' ? "#000000" : "#14889A",   // 上一次主题颜色
        collapse:false,  // 导航栏收缩状态
        menuRouteLoaded:false    // 菜单和路由是否已经加载
    },
    getters: {
        collapse(state){// 对应着上面state
            return state.collapse
        }
    },
    mutations: {
        onCollapse(state){  // 改变收缩状态
            state.collapse = !state.collapse
        },
        setThemeColor(state, themeColor){  // 改变主题颜色
            state.oldThemeColor = state.themeColor
            state.themeColor = themeColor
        },
        menuRouteLoaded(state, menuRouteLoaded){  // 改变菜单和路由的加载状态
            state.menuRouteLoaded = menuRouteLoaded;
        }
    },
    actions: {
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/app.js